(function () {
  function initCollectionSliders() {
    document.querySelectorAll('[data-collection-section]').forEach(function (section) {
      var grid = section.querySelector('[data-collection-grid]');
      var prevBtn = section.querySelector('[data-collection-prev]');
      var nextBtn = section.querySelector('[data-collection-next]');

      if (!grid || !prevBtn || !nextBtn) return;

      function getScrollStep() {
        var card = grid.querySelector('.prod-card');
        if (!card) return 300;
        var gap = parseFloat(getComputedStyle(grid).columnGap) || 12;
        return card.offsetWidth + gap;
      }

      function updateArrows() {
        prevBtn.disabled = grid.scrollLeft <= 1;
        nextBtn.disabled = grid.scrollLeft + grid.offsetWidth >= grid.scrollWidth - 1;
      }

      prevBtn.addEventListener('click', function () {
        grid.scrollBy({ left: -getScrollStep(), behavior: 'smooth' });
      });

      nextBtn.addEventListener('click', function () {
        grid.scrollBy({ left: getScrollStep(), behavior: 'smooth' });
      });

      grid.addEventListener('scroll', updateArrows, { passive: true });

      updateArrows();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionSliders);
  } else {
    initCollectionSliders();
  }
})();
